"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaAvis = void 0;

var _react = _interopRequireWildcard(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _utilitaires = require("../utils/utilitaires.js");

require("../css/mfa-avis.css");

var _MfaEnveloppe = require("./MfaEnveloppe.js");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MfaAvis = /*#__PURE__*/function (_Component) {
  _inherits(MfaAvis, _Component);

  var _super = _createSuper(MfaAvis);

  function MfaAvis(props) {
    _classCallCheck(this, MfaAvis);

    return _super.call(this, props);
  }

  _createClass(MfaAvis, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
        className: this.obtenirNomClasse(),
        celled: true
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
        textAlign: "center",
        className: this.obtenirNomClasseIcon()
      }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        size: "large",
        className: this.obtenirNomClassColor(),
        name: this.obtenirIcon()
      })), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
        width: 12,
        className: "column-message"
      }, (0, _utilitaires.nestPasNulOuVide)(this.props.title) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
        className: "titre"
      }, this.props.title), " ", /*#__PURE__*/_react.default.createElement("br", null), " ", /*#__PURE__*/_react.default.createElement("span", {
        className: "message"
      }, this.props.message)) : (0, _utilitaires.nestPasNulOuVide)(this.props.message) ? /*#__PURE__*/_react.default.createElement("span", {
        className: "message"
      }, this.props.message) : this.props.children))));
    }
  }, {
    key: "obtenirNomClasseIcon",
    value: function obtenirNomClasseIcon() {
      var className = "column-icon";
      className += this.couleurNotification(this.props.codeAvis);
      return "".concat(className);
    }
  }, {
    key: "obtenirTaille",
    value: function obtenirTaille() {
      if ((0, _utilitaires.nestPasNulOuVide)(this.props.taille)) {
        if (this.props.taille === 'lg') {
          return ' largeur-lg';
        }

        if (this.props.taille === 'sm' || this.props.taille === 'md') {
          return ' largeur-md';
        }

        if (this.props.taille === 'xxl') {
          return ' largeur-xxl';
        }
      }

      return ' largeur-xl';
    }
  }, {
    key: "obtenirIcon",
    value: function obtenirIcon() {
      var codeAvis = this.props.codeAvis;
      var icon = "info circle";

      if (codeAvis === 1) {
        icon = "check circle outline";
      }

      if (codeAvis === 2) {
        icon = "times circle";
      }

      if (codeAvis === 3) {
        icon = "exclamation triangle";
      }

      return icon;
    }
  }, {
    key: "obtenirNomClassColor",
    value: function obtenirNomClassColor() {
      var codeAvis = this.props.codeAvis;
      var classname = "color-icon-info";

      if (codeAvis === 1) {
        classname = "color-icon-succes";
      }

      if (codeAvis === 2) {
        classname = "color-icon-erreur";
      }

      if (codeAvis === 3) {
        classname = "color-icon-avertissement";
      }

      return classname;
    }
  }, {
    key: "couleurNotification",
    value: function couleurNotification(codeAvis) {
      var couleur = " info";

      if (codeAvis === 1) {
        couleur = " succes";
      }

      if (codeAvis === 2) {
        couleur = " erreur";
      }

      if (codeAvis === 3) {
        couleur = " avertissement";
      }

      return "".concat(couleur);
    }
  }, {
    key: "obtenirNomClasse",
    value: function obtenirNomClasse() {
      var className = "mfa-avis";
      className += this.obtenirTaille();
      return "".concat(className);
    }
  }]);

  return MfaAvis;
}(_react.Component);

exports.MfaAvis = MfaAvis;